import { useCallback, useEffect, useState } from 'react'
import Icon from '@components/shared/Icon'

import styles from './ThumbsScrollController.module.css'

// scrollWidth - content
// clientWidth - width
// offsetWidth - width + borders

function ThumbsScrollController({ children, forwardRef }) {
	const [show, setShow] = useState(false)

	useEffect(() => {
		const thumbs = forwardRef.current
		if (!thumbs) return
		setShow(thumbs.scrollWidth > thumbs.clientWidth)
	}, [forwardRef])

	const scroll = useCallback(
		(direction) => {
			const thumbs = forwardRef.current
			if (!thumbs) return

			const width = thumbs.offsetWidth
			thumbs.scrollLeft = thumbs.scrollLeft + direction * width
		},
		[forwardRef],
	)

	const left = () => scroll(-1)
	const right = () => scroll(1)

	return (
		<div className={styles.wrap}>
			{show && (
				<div className={styles.controls}>
					<Icon onClick={left}>chevron_left</Icon>
					<Icon onClick={right}>chevron_right</Icon>
				</div>
			)}
			{children}
		</div>
	)
}

export { ThumbsScrollController }
